import $ from 'jquery'

export class CalculatorUnemployment {

  constructor() {
    this.$container = $('.calculator-unemployment')

    if (!this.$container.length) return

    this.$form = this.$container.find('form')
    this.$inputs = this.$form.find('input, select')
    this.$containerWithResult = this.$container.find('.with-results')
    this.$containerWithoutResult = this.$container.find('.no-result')

    this.$baseInput = this.$container.find('#unemp-base')
    this.$monthsInput = this.$container.find('#unemp-months')
    this.$childrenInput = this.$container.find('#unemp-children')
    this.$contributedCheckbox = this.$container.find('#unemp-contributed')

    this.$monthlyAmount = this.$container.find('#unemp-text-contribution')
    this.$durationAmount = this.$container.find('#unemp-text-month')
    this.$totalAmount = this.$container.find('#unemp-text-total')
    this.$error = this.$container.find('.calc-error')

    // read config from data attributes (set in Twig via ACF)
    const iprem = parseFloat(this.$container.attr('data-iprem'))
    const rate = parseFloat(this.$container.attr('data-rate'))
    this.iprem = Number.isFinite(iprem) ? iprem : 600
    this.rate = Number.isFinite(rate) ? rate / 100 : 0.7

    // limits by children (% of IPREM)
    const l0min = parseFloat(this.$container.attr('data-limit-0-min'))
    const l0max = parseFloat(this.$container.attr('data-limit-0-max'))
    const l1min = parseFloat(this.$container.attr('data-limit-1-min'))
    const l1max = parseFloat(this.$container.attr('data-limit-1-max'))
    const l2min = parseFloat(this.$container.attr('data-limit-2-min'))
    const l2max = parseFloat(this.$container.attr('data-limit-2-max'))

    this.limits = {
      0: {
        min: (Number.isFinite(l0min) ? l0min / 100 : 0.8) * this.iprem,
        max: (Number.isFinite(l0max) ? l0max / 100 : 1.75) * this.iprem
      },
      1: {
        min: (Number.isFinite(l1min) ? l1min / 100 : 1.07) * this.iprem,
        max: (Number.isFinite(l1max) ? l1max / 100 : 2.0) * this.iprem
      },
      2: {
        min: (Number.isFinite(l2min) ? l2min / 100 : 1.07) * this.iprem,
        max: (Number.isFinite(l2max) ? l2max / 100 : 2.25) * this.iprem
      }
    }

    this.$form.on('change', this.handleChangeForm.bind(this))
    this.$form.on('input', this.handleSubmitForm.bind(this))
    this.$inputs.on('keyup', this.handleChangeForm.bind(this))

    // run calculation on load with default values
    this.handleChangeForm()
  }

  handleSubmitForm(e) {
    e.preventDefault()
    this.handleChangeForm()
  }

  handleChangeForm() {
    this.$containerWithResult.show()
    this.$containerWithoutResult.hide()

    let monthlyBase = this.toFloat(this.$baseInput.val())
    let monthsContributed = this.toInt(this.$monthsInput.val())
    let childrenRaw = this.toInt(this.$childrenInput.val())
    let childrenCount = childrenRaw >= 2 ? 2 : childrenRaw
    let contributed = this.$contributedCheckbox.is(':checked')

    if (!contributed || monthsContributed < 12) {
      // not entitled
      this.$containerWithResult.hide()
      this.$containerWithoutResult.show()
      return
    }

    // compute theoretical = rate% of monthly base
    let theoretical = monthlyBase * this.rate

    // limits by children
    let limits = this.getLimits(childrenCount)
    let result = Math.min(Math.max(theoretical, limits.min), limits.max)

    // duration mapping
    let duration = this.getDurationMonths(monthsContributed)

    let total = result * duration

    this.applyValue(this.$monthlyAmount, this.round2(result))
    this.applyValue(this.$durationAmount, duration)
    this.applyValue(this.$totalAmount, this.round2(total))
  }

  toInt(v) {
    let n = parseInt(String(v), 10)
    return Number.isFinite(n) ? n : 0
  }

  toFloat(v) {
    let n = parseFloat(String(v))
    return Number.isFinite(n) ? n : 0
  }

  round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100
  }

  applyValue($el, value) {
    if (!$el || !$el.length) return
    let template = $el.data('value') || '%%value%%'
    $el.text(String(template).replace('%%value%%', value))
  }

  getLimits(childrenCount) {
    if (childrenCount <= 0) return this.limits[0]
    if (childrenCount === 1) return this.limits[1]
    return this.limits[2]
  }

  getDurationMonths(months) {
    if (months >= 48) return 24
    if (months >= 43) return 16
    if (months >= 36) return 12
    if (months >= 30) return 10
    if (months >= 24) return 8
    if (months >= 18) return 6
    if (months >= 12) return 4
    return 0
  }
}
